/** WhatsApp Business chat — opens the app or web with a prefilled message. */
export const WHATSAPP_E164 = "919032394343";

export const WHATSAPP_DEFAULT_MESSAGE =
    "Hi LN Sols — I'd like to discuss a software project with you.";

export const WHATSAPP_DISPLAY_NUMBER = "+91 90323 94343";

export function getWhatsAppChatUrl(message = WHATSAPP_DEFAULT_MESSAGE) {
    const text = encodeURIComponent(message);
    return `https://wa.me/${WHATSAPP_E164}?text=${text}`;
}
